import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constant } from '../common/constant';
import { ResidentAddModel } from '../models/resident.model';
import { Observable } from 'rxjs';

@Injectable()
export class ResidentService {

    constructor(private readonly http: HttpClient) {
    }

    registerResidentData(details): Observable<ResidentAddModel> {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.REGISTER_RESIDENT;
        return this.http.post<ResidentAddModel>(url, details);
    }

    registerResidentFamilyData(details): Observable<ResidentAddModel> {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.ADD_RESIDENT_FAMILY;
        return this.http.post<ResidentAddModel>(url, details);
    }

    getAllResident(params, accountId, search, type) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_ALL_RESIDENT
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + search
            + '&accountId=' + accountId + '&type=' + type;
        return this.http.get(url);
    }

    getResidentDataById(id) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_RESIDENT_BY_ID + '?residentId=' + id;
        return this.http.get(url);
    }

    hostCheckOut(id) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.RESIDENT_CHECK_OUT + '?guestId=' + id;
        return this.http.get(url);
    }

    hostCheckOutForServiceProvider(id) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.RESIDENT_CHECK_OUT_FOR_SP + '?serviceProviderId=' + id;
        return this.http.get(url);
    }

    getAllResidentList(accountId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_ALL_RESIDENT_LIST + '?accountId=' + accountId;
        return this.http.get(url);
    }

    getFamilyMemberByFlatId(accountId, flatId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_RESIDENT_BY_FLAT_ID + '?accountId=' + accountId
            + '&flatId=' + flatId;
        return this.http.get(url);
    }

    importResident(formData, accountId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.IMPORT_RESIDENT + '?accountId=' + accountId;
        return this.http.post(url, formData);
    }

    importResidentFamily(formData, accountId, flatId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.IMPORT_RESIDENT_FAMILY + '?accountId=' + accountId +
            '&flatId=' + flatId;
        return this.http.post(url, formData);
    }

    downloadErrorSheet(fileName) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_FILE + '?file_name=' + fileName;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }

    downloadSampleSheet(filename) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.DOWNLOAD_SAMPLE_SHEET + '?fileName=' + filename;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }

    getReidentFamilyMember(residentId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_RESIDENT_FAMILY +
            '?residentId=' + residentId;
        return this.http.get(url);
    }

    checkFlatAvailability(details): Observable<ResidentAddModel> {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.CHECK_PREMISE_AVAILABILITY_FOR_RESIDENT;
        return this.http.post<ResidentAddModel>(url, details);
    }

    regenerateQRCode(residentId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.REGENERATE_RESIDENT_QRCODE +
            '?residentId=' + residentId;
        return this.http.get(url);
    }

    getResidentQRImage(id) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_RESIDENT_QR_IMAGE + '?residentId=' + id;
        return this.http.get(url);
    }

    checkResidentQRExpire(residentId, accountId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.CHECK_RESIDENT_QR_EXPIRE +
            '?residentId=' + residentId + '&accountId=' + accountId;
        return this.http.get(url);
    }

    checkInCheckOutResident(details) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.CHECK_IN_CHECK_OUT;
        return this.http.post(url, details);
    }

    getAllResidentListByAccountId(params, accountId, searchBy, type) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_RESIDENT_CHECK_IN
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
            '&accountId=' + accountId + '&type=' + type;
        return this.http.get(url);
    }

    registerVehicle(details) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.REGISTER_VEHICLE;
        return this.http.post(url, details);
    }

    getVehicleList(accountId, flatId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_VEHICLE_LIST +
            '?flatId=' + flatId + '&accountId=' + accountId;
        return this.http.get(url);
    }

    deleteVehicleInfo(id) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.DELETE_VEHICLE_INFO +
            '?id=' + id;
        return this.http.get(url);
    }

    registerCommercialVehicle(details) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.REGISTER_COMMERCIAL_VEHICLE;
        return this.http.post(url, details);
    }

    regenerateCommercialvehicleQRCode(vehicleId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.REGENERATE_COMMERCIAL_VEHICLE_QRCODE +
            '?vehicleId=' + vehicleId;
        return this.http.get(url);
    }

    getCommericalVehicleList(accountId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_COMMERCIAL_VEHICLE_LIST +
            '?accountId=' + accountId;
        return this.http.get(url);
    }
    importCommercialVehicle(formData, accountId, flatId) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.IMPORT_COMMERCIAL_VEHICLE + '?accountId=' + accountId +
            '&flatId=' + flatId;
        return this.http.post(url, formData);
    }
    downloadErrorVehicleSheet(fileName) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_VEHICLE_FILE + '?file_name=' + fileName;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }
    getAllVehicleList(params, accountId, search, type) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_ALL_COMMERCIAL_VEHICLE
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + search
            + '&accountId=' + accountId + '&type=' + type;
        return this.http.get(url);
    }
    checkInCheckOutCommercialVehicle(details) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.CHECK_IN_CHECK_OUT_COMMERCIAL_VEHICLE;
        return this.http.post(url, details);
    }
    getAllCommercialVehicleListByAccountId(params, accountId, searchBy, type) {
        const url = Constant.REST_URL + Constant.RESIDENT + Constant.GET_COMMERCIAL_VEHICLE_CHECK_IN
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
            '&accountId=' + accountId + '&type=' + type;
        return this.http.get(url);
    }

}
